module.exports = __webpack_public_path__ + "static/media/registed.652565d6.png";